import { render, staticRenderFns } from "./addressCom.vue?vue&type=template&id=c94ad4ea&scoped=true"
import script from "./addressCom.vue?vue&type=script&lang=js"
export * from "./addressCom.vue?vue&type=script&lang=js"
import style0 from "./addressCom.vue?vue&type=style&index=0&id=c94ad4ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94ad4ea",
  null
  
)

export default component.exports